import React, { Component } from 'react';
import Autosuggest from 'react-autosuggest';
import './CompanyAutoComplete.css';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import NumberMaskForm from './numberMaskForm';
import SearchNewNumber from './SearchNewNumber'
class NumberAutocomplete extends Component {
  constructor(props) {
    super(props);
    const searchTerm = props.searchTerm || '';
    this.state = {
      searchTerm,
      suggestions: this.filterNumbers(searchTerm),
      modalOpen: false, // State to handle modal open/close
      secondModalOpen: false, // State to handle the second modal open/close
      tnResultData: []
    };
  }
  toggleModal = () => {
    this.setState({ modalOpen: !this.state.modalOpen });
  };

  componentDidMount() {
    this.setState({
      suggestions: this.filterNumbers(this.state.searchTerm)
    });
  }

  componentDidUpdate(prevProps) {
    if (this.props.searchTerm !== prevProps.searchTerm) {
      this.setState({ searchTerm: this.props.searchTerm || '' });
    }
  }
  filterNumbers = value => {
    const inputValue = value.trim().toLowerCase();
    const { numbers, showUnassigned, includeCallIdMaskNumber } = this.props;
    // Filter the numbers based on the input value
    const filteredNumbers = numbers.filter(item => {
      const number = item?.number ? item.number.toLowerCase() : '';
      const isCallIdMask = item.type === 'callIdMask';
      const notAssigned = !(
        item?.linkedBox ||
        (showUnassigned && item.type !== 'unassigned') ||
        (!showUnassigned && (item.type === 'vmail' || item.type === 'forward'))
      );
       // Include all numbers except 'callIdMask' unless includeCallIdMaskNumber is true
      return notAssigned && number.includes(inputValue) && (includeCallIdMaskNumber || !isCallIdMask);
    });
    // Check if 'Order New' is already in the list to prevent duplicates
    const orderNewExists = filteredNumbers.some(item => item.value === 'order-new');
    // Add the "Order New" option only if it is not already present
    if (!orderNewExists) {
      filteredNumbers.push({ value: 'order-new', label: 'Order New' });
    }
    return filteredNumbers;
  };

  getNumberValue = item => item.number || '';

  // renderSuggestion = item => {
  //   return <div>{item.number || ''}</div>;
  // };

  renderSuggestion = item => {
    if (item.value === 'order-new' && this.props.user?.numberCarrierChangeAccess) {
      return (
        <div style={{ padding: '0', margin: '0', width: '100%' }}>
          {/* A full-width line */}
          <div style={{ width: 'calc(95% + 36px)', marginLeft: '-16px' }}>
            <hr style={{ borderTop: '2px solid #31529f', margin: '0', padding: '0' }} />
          </div>
          <div style={{ color: '#31529f', padding: '0px 0', }}>
            Order New
          </div>
        </div>
      );
    } else {
      return <div>{item.number || ''}</div>;
    }
  };

  onChange = (event, { newValue }) => {
    if (newValue === '') {
      this.props.onChange({ name: 'number', value: null, suggestion: null });
    }
    this.setState({
      searchTerm: newValue,
    });
  };

  // Autosuggest will call this function every time you need to update suggestions.
  // You already implemented this logic above, so just use it.
  onSuggestionsFetchRequested = ({ value }) => {
    this.setState({
      suggestions: this.filterNumbers(value),
    });
  };

  // Autosuggest will call this function every time you need to clear suggestions.
  onSuggestionsClearRequested = () => {
    this.setState({
      suggestions: [],
    });
  };

  // onNumberSelected = (ev, { suggestion, suggestionValue }) => {
  //   const evObj = { name: 'number', value: suggestionValue, suggestion };
  //   this.props.onChange(evObj);
  // };

  onNumberSelected = (ev, { suggestion, suggestionValue }) => {
    if (suggestion.value === 'order-new') {
      // Handle the "Order New" selection
      console.log('Order New selected');
      this.toggleModal();
      return;
    } else {
      const evObj = { name: 'number', value: suggestionValue, suggestion };
      this.props.onChange(evObj);
    }
  };

  onKeyPress = e => {
    if (e.key === 'Enter') {
      const { numbers, userAutocomplete } = this.props;
      const suggestion = !userAutocomplete
        ? numbers.filter(item => item.number === e.currentTarget.value)
        : numbers.filter(item => item.number === e.currentTarget.value);
      this.props.onChange({
        name: 'number',
        value: e.currentTarget.value,
        suggestion: { ...suggestion[0] },
      });
    }
  };
  // Function to open the second modal after closing the parent modal
  openSecondModal = () => {
    this.setState({ secondModalOpen: true });
  };

  // Function to close both modals
  closeModal = () => {
    console.log('Closing parent modal');
    this.setState({ modalOpen: false }, () => {
      this.openSecondModal(); // Open second modal after parent modal is closed
    });
  };
  // Function to handle receiving numbers from the child component
  handleReceiveNumbers = (numbersArray) => {
    console.log('Received numbers from child:', numbersArray);
    this.setState({ tnResultData: numbersArray });
  };

  closeSecondModal = () => {
    this.setState({ secondModalOpen: false, tnResultData: [] });
  };

  handleNext = () => {
    console.log('Next button clicked');
    // Handle next button functionality here
  };
  

  render() {
    const { searchTerm, suggestions } = this.state;
    const { states, clearSearchedNumbers, resetSelectedNumbers } = this.props;
    // Autosuggest will pass through all these props to the input.
    const inputProps = {
      placeholder: this.props.placeholder || 'Search Number...',
      disabled: this.props.isDisabled || false,
      value: searchTerm,
      onChange: this.onChange,
      onKeyPress: this.onKeyPress,
      name: 'number',
      requires: 'true',
      type: 'text',
      className: 'form-control',
      id: 'available_numbers_list'
    };
    const { user } = this.props

    // Finally, render it!
    return (
      <div className={this.props.className || 'autocomplete-container'}>
        <Autosuggest
          suggestions={suggestions}
          onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
          onSuggestionsClearRequested={this.onSuggestionsClearRequested}
          getSuggestionValue={this.getNumberValue}
          renderSuggestion={this.renderSuggestion}
          inputProps={inputProps}
          shouldRenderSuggestions={() => true}
          onSuggestionSelected={this.onNumberSelected}
        />
          {/* Parent Modal */}
          {this.state.modalOpen && (
         <Modal isOpen={this.state.modalOpen} toggle={this.toggleModal}>
         <ModalHeader className="custom-modal-header">
           DID Search
         </ModalHeader>
         <ModalBody>
           {/* <NumberMaskForm/> */}
           <NumberMaskForm 
             user={user} 
             orderNew={true} 
             closeModal={this.closeModal} 
             onReceiveNumbers={this.handleReceiveNumbers} 
             states = {states}
             clearSearchedNumbers={clearSearchedNumbers}
             resetSelectedNumbers={resetSelectedNumbers}
           />
         </ModalBody>
       </Modal>
       
        )}
        {/* Second Modal */}
        <SearchNewNumber
          isOpen={this.state.secondModalOpen}
          tnResultData={this.state.tnResultData}
          onCancel={this.closeSecondModal}
          onNext={this.handleNext}
        />
      </div>
    );
  }
}

export default NumberAutocomplete;
